import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NotificationPreviewListComponent, BackToDashboardLink } from './NotificationPreviewList.styles.js';
import Notification from 'components/_common/notification';
import { markNotificationAsRead } from 'helpers/utilities';
import { Auth } from 'components/context/AuthContext';

const NotificationPreviewList = ({ cta, labels = {} }) => {
  const { url } = cta || {};
  const { userToken, notifications } = useContext(Auth);

  const markNotificationAsReadClickHandler = (notificationId) => {
    markNotificationAsRead(notificationId, userToken);
  };

  return (
    <NotificationPreviewListComponent>
      {notifications?.map((notification, notificationIndex) => {
        return (
          <Notification
            key={`notification-${notificationIndex}`}
            {...notification}
            onClick={markNotificationAsReadClickHandler}
            notification={notification}
          />
        );
      })}
      <BackToDashboardLink
        linkText={labels.back_to_dashboard_cta_text || 'Back to dashboard'}
        linkHref={labels.dashboard_url || url}
        isExternal={false}
        target="_self"
        iconName="chevronLeft"
        dark
      />
    </NotificationPreviewListComponent>
  );
};

NotificationPreviewList.propTypes = {
  labels: PropTypes.shape({
    back_to_dashboard_cta_text: PropTypes.string,
    dashboard_url: PropTypes.string,
  }),
  cta: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    alt: PropTypes.string,
    isExternal: PropTypes.bool,
  }),
};

export default NotificationPreviewList;
